import ApplicationSerializer from "./application";

export default class FileStorageVolumeSerializer extends ApplicationSerializer {
  usesProxy = true;

  primaryKey = "volumeid";

  attrs = {
    accessList: "accesslist",
    dataCenter: "datacenter",
    hasAutoPromotion: "autopromotion",
    isLocked: "islocked",
  };

  serialize() {
    let json = super.serialize(...arguments);

    json.planid = json.plan.planid;
    json.accesslist = json.accesslist?.join(",");
    json.projectkey = json.project;

    return json;
  }
}
